import * as loadingState from '../constants/loadingState';

export const CHANGE_SCHOOL_INITIALIZE = 'CHANGE_SCHOOL_INITIALIZE';
export const CHANGE_SCHOOL = 'CHANGE_SCHOOL';
export const CHANGE_SCHOOL_SUCCESS = 'CHANGE_SCHOOL_SUCCESS';
export const CHANGE_SCHOOL_ERROR = 'CHANGE_SCHOOL_ERROR';
export const CHANGE_SCHOOL_COMPLETE = 'CHANGE_SCHOOL_COMPLETE';
export const CLOSE_EDIT_PANEL = 'CLOSE_EDIT_PANEL';

export const changeSchoolInitialize = () => ({
  type: CHANGE_SCHOOL_INITIALIZE,
});
export const changeSchool = ({ schoolName, schoolId, userId }) => ({
  type: CHANGE_SCHOOL,
  payload: {
    schoolId,
    schoolName,
    userId,
  },
});

export const changeSchoolSuccess = () => ({ type: CHANGE_SCHOOL_SUCCESS });

export const changeSchoolError = errorCode => ({
  type: CHANGE_SCHOOL_ERROR,
  payload: {
    errorCode,
  },
});

export const changeSchoolComplete = () => ({ type: CHANGE_SCHOOL_COMPLETE });

export const closeEditPanel = () => ({ type: CLOSE_EDIT_PANEL });

const INIT_STATE = {
  changeSchoolOpen: false,
  changeSchoolStatus: loadingState.EMPTY,
  errorCode: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_SCHOOL_INITIALIZE:
      return {
        ...state,
        changeSchoolStatus: loadingState.EMPTY,
        changeSchoolOpen: true,
        errorCode: '',
      };
    case CHANGE_SCHOOL:
      return {
        ...state,
        changeSchoolStatus: loadingState.LOADING,
      };
    case CHANGE_SCHOOL_SUCCESS:
      return {
        ...state,
        changeSchoolStatus: loadingState.READY,
        changeSchoolOpen: false,
        errorCode: '',
      };
    case CHANGE_SCHOOL_ERROR:
      return {
        ...state,
        changeSchoolStatus: loadingState.ERROR,
        errorCode: action.payload.errorCode,
      };
    case CHANGE_SCHOOL_COMPLETE:
      return {
        ...state,
        changeSchoolStatus: loadingState.EMPTY,
        changeSchoolOpen: false,
        errorCode: '',
      };
    case CLOSE_EDIT_PANEL:
      return {
        ...state,
        changeSchoolOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getErrorCode = state => state.changeSchool.errorCode;
export const getOpenStatus = state => state.changeSchool.changeSchoolOpen;



// WEBPACK FOOTER //
// ./app/redux/changeSchool.js